import type { ReactNode } from "react";
import { cardBorderClassName } from "../lib/cardStyles";

export default function Card({
  children,
  className = "",
  padding = "p-6",
}: {
  children: ReactNode;
  className?: string;
  padding?: string;
}) {
  return (
    <div
      className={`rounded-xl ${padding} ${cardBorderClassName} ${className}`.trim()}
      style={{ background: "rgba(28,28,37,0.8)" }}
    >
      {children}
    </div>
  );
}

export function SectionHeading({
  icon,
  children,
  className = "",
}: {
  icon?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex items-center gap-3 mb-4 ${className}`.trim()}>
      {icon && <i className={`${icon} text-purple-400 text-xl`} aria-hidden />}
      <h2
        className="text-xl font-semibold text-white"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        {children}
      </h2>
    </div>
  );
}
